<template>
    <div v-if="timeRemaining > 0">
        <b-button variant="danger" @click="cancelOrder(order)"
                  class="ml-1 mr-1">
            {{ $t('Annulla') }}
        </b-button>

        <span>
            {{ $t("Hai {timeRemaining} min per annullare", {timeRemaining: timeRemaining}) }}
        </span>
    </div>
</template>

<script>
    export default {
        name: "OrdersCancelOrder",
        props: ["order", "activationDate"],

        data() {
            return {
                timeRemaining: 0
            }
        },

        mounted() {
            this.updateCancelTime();
        },

        methods: {
            updateCancelTime() {
                this.timeRemaining = this.calculateCancelTime(this.order);

                if (this.timeRemaining > 0) {
                    setTimeout(() => {
                        this.updateCancelTime();
                    }, (60 * 1000));
                }
            },

            calculateCancelTime(order) {
                var timeRemaining = 0;
                if (['0', 'FV'].includes(order.status) && order.paymentType === 'Fido') {
                    var cancelDateStart = null;
                    var cancelTime = parseInt(order.cancelTime);
                    var orderDate = this.$utilsService.getDateFromString(order.creationDate);
                    var activationDate = this.activationDate ? this.$utilsService.getDateFromString(this.activationDate) : null;
                    if (activationDate !== null && orderDate < activationDate) {
                        cancelDateStart = activationDate;
                    } else {
                        cancelDateStart = orderDate;
                    }
                    var limit = new Date(cancelDateStart.getTime());
                    limit.setMinutes(cancelDateStart.getMinutes() + cancelTime);
                    var now = new Date();
                    timeRemaining = parseInt((limit - now) / 60000);
                    if (timeRemaining < 0) timeRemaining = 0;
                }

                return timeRemaining;
            },

            cancelOrder() {
                if (this.calculateCancelTime(this.order) > 0) {
                    this.$emit("cancelOrder", this.order);
                }
            }
        }
    };
</script>

<style scoped>
</style>
